import React, { useState, useEffect, useContext } from "react";
import { Button, Form } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../../../Shared/AdminNavbar/Navbar";
import "./InDetailViewLeads.css";
import axios from "axios";
import baseURL  from "../../../../Apiurs/Apiurls";
import { FaCopy } from "react-icons/fa";
// import { ThemeContext } from "../../../../../Shared/Themes/ThemeContext";

const InDetailViewLeads = () => {
  const navigate = useNavigate();
  const { leadid } = useParams();
  const [collapsed, setCollapsed] = useState(false);
  const [newComment, setNewComment] = useState('');
  const [assignedSalesId, setAssignedSalesId] = useState(null);
  const [managerid, setManagerId] = useState(null);
  const [lead, setLead] = useState({ comments: [] });
  const [formData, setFormData] = useState({
    lead_name: "",
    business_name: "",
    lead_source: "",
    contact_number: "",
    email: "",
    whatsapp_number: "",
    preferred_contact_method: "",
    product: "",
    quantity: "",
    description: "",
    assigned_to: "",
    assigned_by: "",
    created_at: "",
    products: [] // added for products table
  });
  const [error, setError] = useState(null);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  // const { themeColor } = useContext(ThemeContext);
const themeColor = "#007bff"; 
  const copyToClipboard = (text) => {
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
      setMessage("Copied to clipboard!");
      setTimeout(() => setMessage(""), 1000);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  };

  // Fetch Lead Data
  useEffect(() => {
    const fetchLeadData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${baseURL}/api/contacts/${leadid}`);
        const leadData = response.data;
        const leadItem = Array.isArray(leadData) ? leadData[0] : leadData;

        if (leadItem) {
          setFormData({
            lead_name: leadItem.lead_name || "",
            business_name: leadItem.business_name || "",
            lead_source: leadItem.lead_source || "",
            contact_number: leadItem.contact_number || "",
            email: leadItem.email || "",
            whatsapp_number: leadItem.whatsapp_number || "",
            preferred_contact_method: leadItem.preferred_contact_method || "",
            product: leadItem.product || "",
            quantity: leadItem.quantity || "",
            description: leadItem.description || "",
            assigned_to: leadItem.assigned_to || "",
            assigned_by: leadItem.assigned_by || "",
            created_at: leadItem.created_at || "",
            products: leadItem.products || [] // set products
          });
        } else {
          setError("Lead not found");
        }
      } catch (err) {
        console.error("Error fetching lead data:", err);
        if (err.response && err.response.status === 404) {
          navigate("/not-found");
        } else {
          setError("Failed to fetch lead data.");
        }
      } finally {
        setLoading(false);
      }
    };

    if (leadid) fetchLeadData();
  }, [leadid, navigate]);

  // Fetch Comments
  useEffect(() => {
    const fetchLeadDetails = async () => {
      try {
        const response = await fetch(`${baseURL}/api/leadsoppcomment/${leadid}`);
        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();
        setLead(data || { comments: [] });
      } catch (error) {
        console.error('Error fetching lead details:', error);
      }
    };
    if (leadid) fetchLeadDetails();
  }, [leadid]);

  // Add Comment
  const addComment = async () => {
    if (!newComment.trim()) return;
    const trimmedComment = newComment.trim();
    const commentName = "Admin";

    const comment = {
      name: commentName,
      leadid: leadid,
      timestamp: new Date().toISOString(),
      text: trimmedComment,
      notificationmessage: `${commentName}:${trimmedComment}  `,
      managerId: managerid,
      userId: assignedSalesId,
      email: null
    };

    try {
      const response = await fetch(`${baseURL}/comments/add`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(comment),
      });
      if (!response.ok) throw new Error("Failed to add comment");
      const savedComment = await response.json();
      setLead(prevLead => ({
        ...prevLead,
        comments: [...prevLead.comments, savedComment]
      }));
      setNewComment('');
    } catch (error) {
      console.error('Error adding comment:', error);
    }
  };

  const sortedComments = lead.comments
    ? lead.comments.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
    : [];

  if (loading) return (
    <div className="indeatilleadcontainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`indeatilleadcontent ${collapsed ? "collapsed" : ""}`}>
        <div className="indetail-container text-center mt-4">Loading lead details...</div>
      </div>
    </div>
  );

  if (error) return (
    <div className="indeatilleadcontainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`indeatilleadcontent ${collapsed ? "collapsed" : ""}`}>
        <div className="indetail-container mt-4">
          <div className="alert alert-danger">{error}</div>
          <button className="btn btn-secondary mt-3" onClick={() => navigate(-1)}>Back</button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="indeatilleadcontainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`indeatilleadcontent ${collapsed ? "collapsed" : ""}`}>
        <div className="indetail-container">

          {/* Lead Details Card */}
          <div className="card mt-4">
            <div className="card-body">
              {/* <h2 className="lead-details-header" style={{ "--theme-color": themeColor }}>Lead Details</h2> */}
              <h2 className="lead-details-header" style={{ color: 'black' }}>Lead Details</h2>
              {message && <div className="alert alert-info">{message}</div>}
              <div className="row">

                {/* Left Column */}
                <div className="col-md-6">
                  {["lead_name","business_name","lead_source","contact_number","whatsapp_number","preferred_contact_method","email","assigned_to","assigned_by","created_at"].map((field, idx) => (
                    <div className="mb-3 d-flex flex-wrap" key={idx}>
                      <span className="fw-bold me-2" style={{ minWidth: "200px" }}>
                        {field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}:
                      </span>
                      <span>
                        {field === "created_at"
                          ? formData.created_at
                            ? new Date(formData.created_at).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })
                            : '-'
                          : formData[field] || '-'
                        }
                      </span>
                      {["contact_number","whatsapp_number","email"].includes(field) && formData[field] && (
                        <FaCopy
                          style={{ marginLeft: "8px", cursor: "pointer", color: "#ff9966" }}
                          onClick={() => copyToClipboard(formData[field])}
                          title={`Copy ${field.replace("_"," ")}`}
                        />
                      )}
                    </div>
                  ))}
                </div>

                {/* Right Column - Comments */}
                <div className="col-md-6">
                  <div className="comment-section-container">
                    <div className="comment-input-container">
                      <Form.Group>
                        <Form.Label><strong>Add a New Comment</strong></Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          placeholder="Write your comment here..."
                          value={newComment}
                          onChange={(e) => setNewComment(e.target.value)}
                          autoFocus
                        />
                        <Button
                          // className="mt-2 btn-warning text-white"
                           className="mt-2 btn-warning text-black"
                          onClick={addComment}
                          disabled={!newComment.trim()}
                        >
                          Add Comment
                        </Button>
                      </Form.Group>
                    </div>
                    <div className="comment-list" style={{ maxHeight: "300px", overflowY: "auto", border: "1px solid #ddd", padding: "10px", borderRadius: "5px", marginTop: "15px", backgroundColor: "#f1f7ff" }}>
                      {sortedComments.length > 0 ? (
                        sortedComments.map((comment) => (
                          <div key={comment.id} className="mb-2">
                            <strong>{comment.name}</strong>{" "}
                            <small className="text-muted">({new Date(comment.timestamp).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })})</small>
                            <div>{comment.text}</div>
                          </div>
                        ))
                      ) : (
                        <p className="text-muted">No comments yet.</p>
                      )}
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          {/* Products Table */}
            <div className="card mt-4">
            <div className="card-body">
          {formData.products && formData.products.length > 0 && (
             
            <div className="col-md-12">
            {/* <h4 className="lead-details-header" style={{ "--theme-color": themeColor }}> */}
 <h4 className="lead-details-header" style={{ color: 'black' }}>
                Products Details
              </h4>
              <div className="table-responsive">
                <table className="table table-bordered table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>PR No</th>
                      <th>PR Date</th>
                      <th>Legacy Code</th>
                      <th>Item Code</th>
                      <th>Description</th>
                      <th>UOM</th>
                      <th>Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formData.products.map((product, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{product.pr_no || "-"}</td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {product.pr_date}
                        </td>
                        <td>{product.legacy_code || "-"}</td>
                        <td>{product.item_code || "-"}</td>
                        <td style={{ whiteSpace: "pre-line" }}>{product.item_description || "-"}</td>
                        <td>{product.uom || "-"}</td>
                        <td>{product.pr_quantity || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            
          )}
</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InDetailViewLeads;
